import React, { useCallback } from "react";
import { connect } from "react-redux";
import { withTheme } from "@material-ui/core";

import {
  fetchRoutes,
  setMapBounds,
  setMapCenter
} from "../../store/actions/map";
import { setExtendableId, setExtendableType } from "../../store/actions/edit";
import { toggleDrawer } from "../../store/actions/common";

import Controls from "./controls";
import useStyles from "./styles";

import useMapHooks from "./hooks";
import UnsavedChangesDialog from "../dialogs/UnsavedChangesDialog";
import { setShowingRouteId } from "../../store/actions/project";
import DriverMarkers from "../map/DriverMarkers";
import "ol/ol.css";
import "ol-ext/dist/ol-ext.css";

const MapOl = props => {
  // General
  const classes = useStyles();

  const refitServicesBounds = useCallback(() => refitMarkersExtent(), []);
  // hooks
  const {
    mapRef,
    refitMarkersExtent,
    createMap,
    changesDialog,
    setChangesDialog,
    handleClick
  } = useMapHooks(props);

  return (
    <div id="map_ol_container" className={classes.mapContainer}>
      <Controls mapRef={mapRef} refitServicesBounds={refitServicesBounds} />
      <div
        id="map_ol"
        className={classes.map}
        ref={element => {
          if (!mapRef.current) {
            createMap(element);
          }
        }}
      ></div>
      {props.publishedOnce && <DriverMarkers />}
      <UnsavedChangesDialog
        open={changesDialog.visible}
        key={-1}
        handleClose={() => setChangesDialog({ visible: false })}
        action={() =>
          handleClick(
            changesDialog.id,
            changesDialog.type,
            changesDialog.status
          )
        }
      />
    </div>
  );
};

function mapStateToProps(state) {
  return {
    organisation:
      state.auth.userData.organisationSite &&
      state.auth.userData.organisationSite.organisation,
    projectId: state.project.id,
    solution: state.project.solution,
    tilesDark: state.map.tilesDark,
    plan:
      (state.auth.userData.organisationSite &&
        state.auth.userData.organisationSite.organisation.plan) ||
      {},
    refitHash: state.map.refitHash,
    markersHidden: state.map.markersHidden,
    markersClustered: state.map.markersClustered,
    unscheduledMarkersHidden: state.map.unscheduledMarkersHidden,
    editId: state.extendable.type === "stops" && state.extendable.id,
    saveDisabled: state.extendable.saveDisabled,
    isReloadAllowed: state.project.vrp.configuration.allow_reload,
    colorsObj: state.project.solution && state.project.solution.routeColors,
    polylines: state.map.polylines,
    services: state.project.vrp.stops,
    showingRouteId: state.project.showingRouteId,
    snapToRoadEnabled: state.map.snapToRoadEnabled,
    publishedOnce: state.project.published_once,
    driverLocations: state.map.isDriverLiveLocationVisible
      ? state.map.driverLocations
      : {},
    vehicles: state.project.vehicles,
    hoveredStop: state.map.hoverStop
  };
}

export default connect(mapStateToProps, {
  setMapCenter,
  setMapBounds,
  setExtendableId,
  setExtendableType,
  toggleDrawer,
  fetchRoutes,
  setShowingRouteId
})(withTheme(MapOl));
